import React from 'react'
import SellerImg1 from "../assets/images/SellerImg1.png";
import SellerImg2 from "../assets/images/SellerImg2.png";
function SellerBase() {
    return (
        <div>
            <div className='container '>
                <div className='row py-5'>
                    <div className='order-2 order-lg-1 mt-5 mt-lg-0  col-lg-6 d-flex justify-content-center align-items-center'>
                        <div>
                            <h1 className='font-face-PlusJakartaSans-Bold'>Sellers in RealtyBase</h1>
                            <ul className='d-flex flex-column gap-3 fs-5 mt-4 w-75 font-face-PlusJakartaSans-Regular'>
                                <li>List your house for 0% commission. Simple mobile friendly forms</li>
                                <li>Coordinate listing photos</li>
                                <li>Schedule home inspection</li>
                                <li>Manage showing times and access</li>
                                <li>Receive, counter and accept offers</li>
                                <li>Close remotely</li>
                                <li>Chat directly with verified buyers</li>
                                <li>Receive alerts and push notifications for showings, offers, and third party appointments</li>
                            </ul>
                        </div>
                    </div>
                    <div className='order-1 order-lg-2 col-lg-6'>
                        <div>
                            <img src={SellerImg2} className='img-fluid' />
                        </div>
                    </div>
                </div>
                <div className='row pt-md-5'>
                    <div className='  col-lg-6'>
                        <div>
                            <img src={SellerImg1} className='img-fluid' />
                        </div>
                    </div>
                    <div className=' mt-5 mt-lg-0  col-lg-6 d-flex justify-content-center align-items-center'>
                        <div>
                            <h1 className='font-face-PlusJakartaSans-Bold'>Buyers in RealtyBase</h1>
                            <ul className='d-flex flex-column gap-3 fs-5 mt-4 w-100 font-face-PlusJakartaSans-Regular' >
                                <li>Search listing using map or list views</li>
                                <li>Favorite your preferred listings</li>
                                <li>Request showings</li>
                                <li>Submit offers using simple forms</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default SellerBase